var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LONG_READ_SPLIT, LONG_READ_CONNECT, LONG_READ_DRAG_END } from '../actions/longreadblocks';
import { GET_LONG_READ_POST_REQUEST, GET_LONG_READ_POST_SUCCESS, GET_LONG_READ_POST_ERROR, GET_LONG_READ_POST_PAGINATED_REQUEST, GET_LONG_READ_POST_PAGINATED_SUCCESS, GET_LONG_READ_POST_PAGINATED_ERROR } from '../actions/getLongReadPosts';
import { ADD_LR_POST_TIMEOUT_START, ADD_LR_POST_TIMEOUT_END, ADD_MANY_LR_POST_TIMEOUT_START, ADD_MANY_LR_POST_TIMEOUT_END } from '../actions/addLongReadPost';
import { UPDATE_LR_POST_TIMEOUT_START, UPDATE_LR_POST_TIMEOUT_END, LONGREAD_RESET_REQUESTED } from '../actions/updateLongReadPost';
import { filterObjectById, updateObjectById, updateObjectByIdAndAddBlocks, updateObjectByIdAndFilterBlocks } from "../utilites/newReducerHelpers";
// тип 1 - текст блок с буквой
// тип 2 - текст блок без буквы и заголовка
// тип 3 - большая картинка
// тип 4 - текст с гербом
var initialState = {
/*  isFetching: false,
  isError: false,
  isDragEnd: false,
  isAddingPost: false,
  blocks: []*/
};
var initialLgData = {
    isFetching: false,
    isError: false,
    isDragEnd: false,
    isAddingPost: false,
    blocks: [],
    pagination: {
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        hasMore: true,
        isLoading: false
    }
};
export function longreadBlocksReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case LONG_READ_SPLIT:
            // return { ...state, blocks: action.payload }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { blocks: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.data }, initialLgData);
        case LONG_READ_DRAG_END:
            // return { ...state, blocks: action.payload, isDragEnd: true }
            return updateObjectById(state, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.lgId, { blocks: (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data, isDragEnd: true }, initialLgData);
        case LONG_READ_CONNECT:
            // return { ...state, blocks: action.payload }
            return updateObjectById(state, (_f = action.payload) === null || _f === void 0 ? void 0 : _f.lgId, { blocks: (_g = action.payload) === null || _g === void 0 ? void 0 : _g.data }, initialLgData);
        case GET_LONG_READ_POST_SUCCESS:
            // return { ...state, blocks: action.payload, isDragEnd: false }
            return updateObjectById(state, (_h = action.payload) === null || _h === void 0 ? void 0 : _h.lgId, { blocks: (_j = action.payload) === null || _j === void 0 ? void 0 : _j.data, isDragEnd: false }, initialLgData);
        case GET_LONG_READ_POST_PAGINATED_REQUEST:
            return updateObjectById(state, (_k = action.payload) === null || _k === void 0 ? void 0 : _k.lgId, {
                pagination: __assign(__assign({}, (_m = state[(_l = action.payload) === null || _l === void 0 ? void 0 : _l.lgId]) === null || _m === void 0 ? void 0 : _m.pagination), { isLoading: true })
            }, initialLgData);
        case GET_LONG_READ_POST_PAGINATED_SUCCESS:
            var currentBlocks = ((_p = state[(_o = action.payload) === null || _o === void 0 ? void 0 : _o.lgId]) === null || _p === void 0 ? void 0 : _p.blocks) || [];
            var newBlocks = ((_q = action.payload) === null || _q === void 0 ? void 0 : _q.page) === 1 ? (_r = action.payload) === null || _r === void 0 ? void 0 : _r.data : __spreadArray(__spreadArray([], currentBlocks, true), (_s = action.payload) === null || _s === void 0 ? void 0 : _s.data, true);
            var receivedItemsCount = ((_u = (_t = action.payload) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.length) || 0;
            var hasMore = receivedItemsCount === ((_v = action.payload) === null || _v === void 0 ? void 0 : _v.limit);
            return updateObjectById(state, (_w = action.payload) === null || _w === void 0 ? void 0 : _w.lgId, {
                blocks: newBlocks,
                isDragEnd: false,
                pagination: {
                    currentPage: (_x = action.payload) === null || _x === void 0 ? void 0 : _x.page,
                    totalPages: hasMore ? ((_y = action.payload) === null || _y === void 0 ? void 0 : _y.page) + 1 : (_z = action.payload) === null || _z === void 0 ? void 0 : _z.page,
                    totalItems: (((_0 = action.payload) === null || _0 === void 0 ? void 0 : _0.page) - 1) * ((_1 = action.payload) === null || _1 === void 0 ? void 0 : _1.limit) + receivedItemsCount,
                    hasMore: hasMore,
                    isLoading: false
                }
            }, initialLgData);
        case GET_LONG_READ_POST_PAGINATED_ERROR:
            return updateObjectById(state, (_2 = action.payload) === null || _2 === void 0 ? void 0 : _2.lgId, {
                pagination: __assign(__assign({}, (_4 = state[(_3 = action.payload) === null || _3 === void 0 ? void 0 : _3.lgId]) === null || _4 === void 0 ? void 0 : _4.pagination), { isLoading: false })
            }, initialLgData);
        case ADD_LR_POST_TIMEOUT_START:
            /*      return {
                    ...state,
                    isAddingPost: true,
                    blocks: [...state.blocks, action.payload]
                  }*/
            return updateObjectByIdAndAddBlocks(state, (_5 = action.payload) === null || _5 === void 0 ? void 0 : _5.lgId, (_6 = action.payload) === null || _6 === void 0 ? void 0 : _6.data, { isAddingPost: true }, (_7 = action.payload) === null || _7 === void 0 ? void 0 : _7.reverseParam);
        case ADD_MANY_LR_POST_TIMEOUT_START:
            /*      return {
                    ...state,
                    isAddingPost: true,
                    blocks: [...state.blocks, ...action.payload]
                  }*/
            return updateObjectByIdAndAddBlocks(state, (_8 = action.payload) === null || _8 === void 0 ? void 0 : _8.lgId, (_9 = action.payload) === null || _9 === void 0 ? void 0 : _9.data, { isAddingPost: true }, (_10 = action.payload) === null || _10 === void 0 ? void 0 : _10.reverseParam);
        case ADD_MANY_LR_POST_TIMEOUT_END:
            // return { ...state, isAddingPost: false }
            return updateObjectById(state, (_11 = action.payload) === null || _11 === void 0 ? void 0 : _11.lgId, { isAddingPost: false }, initialLgData);
        case ADD_LR_POST_TIMEOUT_END:
            // return { ...state, isAddingPost: false }
            return updateObjectById(state, (_12 = action.payload) === null || _12 === void 0 ? void 0 : _12.lgId, { isAddingPost: false }, initialLgData);
        case UPDATE_LR_POST_TIMEOUT_START:
            /*      return {
                    ...state,
                    isAddingPost: true,
                    blocks: [
                      ...state.blocks.filter(
                        (item) => action.payload.position != item.position
                      ),
                      action.payload
                    ]
                  }*/
            return updateObjectByIdAndAddBlocks(updateObjectByIdAndFilterBlocks(state, (_13 = action.payload) === null || _13 === void 0 ? void 0 : _13.lgId, (_15 = (_14 = action.payload) === null || _14 === void 0 ? void 0 : _14.data[0]) === null || _15 === void 0 ? void 0 : _15.position, { isAddingPost: true }), (_16 = action.payload) === null || _16 === void 0 ? void 0 : _16.lgId, (_17 = action.payload) === null || _17 === void 0 ? void 0 : _17.data, {});
        case UPDATE_LR_POST_TIMEOUT_END:
            // return { ...state, isAddingPost: false }
            return updateObjectById(state, (_18 = action.payload) === null || _18 === void 0 ? void 0 : _18.lgId, { isAddingPost: false }, initialLgData);
        case LONGREAD_RESET_REQUESTED:
            // return { ...initialState }
            return filterObjectById(state, (_19 = action.payload) === null || _19 === void 0 ? void 0 : _19.lgId);
        default:
            return state;
    }
}
export function getCurrentLongread(state, lgId) {
    return state.longreadBlocks[lgId] || initialLgData;
}
export function getAllLongreadBlocks(state) {
    return state.longreadBlocks || [];
}
export function getLongreadList(state) {
    return state.longreadBlocks || [];
}
/*

        {
          id: `question-1`,
          type: 1,
          title: `Giant Octopus boiled in citric acid and rose water. Ph'n 1`,
          isConnect: true,
          isDrag: true,
          answers: [
            {
              id: 11,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
              Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
              feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
              vitae at lobortis faucibus. Molestie cursus et euismod in. Diam ullamcorper nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.</p>`
            },
            {
              id: 12,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
              Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
              feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
              vitae at lobortis faucibus. Molestie cursus et euismod in</p>`
            },
            {
                id: 13,
                type: 'text',
                isDrag: true,
                isCut: true,
                text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
                Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
                feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
                vitae at lobortis faucibus. Molestie cursus et euismod in </p>`
            },
            {
              id: 14,
              isDrag: true,
              isCut: true,
              type: 'image',
              url: ``
            }
          ]
        },
        {
          id: `question-2`,
          type: 2,
          title: `Giant Octopus boiled in citric acid and rose water. Ph'n 1`,
          isConnect: true,
          isDrag: true,
          answers: [
            {
              id: 21,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
              Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
              feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
              vitae at lobortis faucibus. Molestie cursus et euismod in. Diam ullamcorper nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.</p>`
            },
            {
              id: 22,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p> et euismod in. Diam ullamcorper nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.et euismod in. Diam ullamcorper
              nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.</p>`
            },
          ]
        },
        {
          id: 'question-3',
          type: 4,
          isConnect: true,
          isDrag: true,
          name: `<p>Конкретно-принципиальная республика Флорида расположена в 80-х меридианах Запада, и входит в Лигу Геркулеса. </p>`
        },
        {
          id: 'question-4',
          type: 5,  // блок соревнуйтесь
          isConnect: true,
          isDrag: true,
          title: 'Соревнуйтесь',
          name: `<p>Легенды и мифы Лиги Геркулеса принадлежат всем странам, входящим в нее.
          Но у каждой страны должна быть и собственная мифология.
          Также и Конкретно-принципиальная республика Флорида нуждается в своих легендах, сказках, анекдотах и тостах.</p>`
        },
        {
          id: 'question-5',
          type: 6,  // блок с лигами
          isConnect: true,
          isDrag: true,
          title: 'Соревнуйтесь',
          name: `<p>Ознакомьтесь с правилами турниров, проходящих в этих Лигах, принимайте в них участие и побеждайте!</p>`,
          leagues: [
            {
              name: 'Лига пчелы'
            },
            {
              name: 'Лига орла'
            },
            {
              name: 'Лига Рыцарей'
            },
            {
              name: 'Лига Единорога'
            },
            {
              name: 'Лига Медведя'
            },
            {
              name: 'Лига Льва'
            },
            {
              name: 'Лига Дракона'
            },
          ]
        }
*/
//# sourceMappingURL=longreadBlocks.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LONG_READ_SPLIT, LONG_READ_CONNECT, LONG_READ_DRAG_END } from '../actions/longreadblocks';
import { GET_LONG_READ_POST_REQUEST, GET_LONG_READ_POST_SUCCESS, GET_LONG_READ_POST_ERROR, GET_LONG_READ_POST_PAGINATED_REQUEST, GET_LONG_READ_POST_PAGINATED_SUCCESS, GET_LONG_READ_POST_PAGINATED_ERROR } from '../actions/getLongReadPosts';
import { ADD_LR_POST_TIMEOUT_START, ADD_LR_POST_TIMEOUT_END, ADD_MANY_LR_POST_TIMEOUT_START, ADD_MANY_LR_POST_TIMEOUT_END } from '../actions/addLongReadPost';
import { UPDATE_LR_POST_TIMEOUT_START, UPDATE_LR_POST_TIMEOUT_END, LONGREAD_RESET_REQUESTED } from '../actions/updateLongReadPost';
import { filterObjectById, updateObjectById, updateObjectByIdAndAddBlocks, updateObjectByIdAndFilterBlocks } from "../utilites/newReducerHelpers";
// тип 1 - текст блок с буквой
// тип 2 - текст блок без буквы и заголовка
// тип 3 - большая картинка
// тип 4 - текст с гербом
var initialState = {
/*  isFetching: false,
  isError: false,
  isDragEnd: false,
  isAddingPost: false,
  blocks: []*/
};
var initialLgData = {
    isFetching: false,
    isError: false,
    isDragEnd: false,
    isAddingPost: false,
    blocks: [],
    pagination: {
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        hasMore: true,
        isLoading: false
    }
};
export function longreadBlocksReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case LONG_READ_SPLIT:
            // return { ...state, blocks: action.payload }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { blocks: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.data }, initialLgData);
        case LONG_READ_DRAG_END:
            // return { ...state, blocks: action.payload, isDragEnd: true }
            return updateObjectById(state, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.lgId, { blocks: (_e = action.payload) === null || _e === void 0 ? void 0 : _e.data, isDragEnd: true }, initialLgData);
        case LONG_READ_CONNECT:
            // return { ...state, blocks: action.payload }
            return updateObjectById(state, (_f = action.payload) === null || _f === void 0 ? void 0 : _f.lgId, { blocks: (_g = action.payload) === null || _g === void 0 ? void 0 : _g.data }, initialLgData);
        case GET_LONG_READ_POST_SUCCESS:
            // return { ...state, blocks: action.payload, isDragEnd: false }
            return updateObjectById(state, (_h = action.payload) === null || _h === void 0 ? void 0 : _h.lgId, { blocks: (_j = action.payload) === null || _j === void 0 ? void 0 : _j.data, isDragEnd: false }, initialLgData);
        case GET_LONG_READ_POST_PAGINATED_REQUEST:
            return updateObjectById(state, (_k = action.payload) === null || _k === void 0 ? void 0 : _k.lgId, {
                pagination: __assign(__assign({}, (_m = state[(_l = action.payload) === null || _l === void 0 ? void 0 : _l.lgId]) === null || _m === void 0 ? void 0 : _m.pagination), { isLoading: true })
            }, initialLgData);
        case GET_LONG_READ_POST_PAGINATED_SUCCESS:
            var currentBlocks = ((_p = state[(_o = action.payload) === null || _o === void 0 ? void 0 : _o.lgId]) === null || _p === void 0 ? void 0 : _p.blocks) || [];
            var newBlocks = ((_q = action.payload) === null || _q === void 0 ? void 0 : _q.page) === 1 ? (_r = action.payload) === null || _r === void 0 ? void 0 : _r.data : __spreadArray(__spreadArray([], currentBlocks, true), (_s = action.payload) === null || _s === void 0 ? void 0 : _s.data, true);
            var receivedItemsCount = ((_u = (_t = action.payload) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.length) || 0;
            var hasMore = receivedItemsCount === ((_v = action.payload) === null || _v === void 0 ? void 0 : _v.limit);
            return updateObjectById(state, (_w = action.payload) === null || _w === void 0 ? void 0 : _w.lgId, {
                blocks: newBlocks,
                isDragEnd: false,
                pagination: {
                    currentPage: (_x = action.payload) === null || _x === void 0 ? void 0 : _x.page,
                    totalPages: hasMore ? ((_y = action.payload) === null || _y === void 0 ? void 0 : _y.page) + 1 : (_z = action.payload) === null || _z === void 0 ? void 0 : _z.page,
                    totalItems: (((_0 = action.payload) === null || _0 === void 0 ? void 0 : _0.page) - 1) * ((_1 = action.payload) === null || _1 === void 0 ? void 0 : _1.limit) + receivedItemsCount,
                    hasMore: hasMore,
                    isLoading: false
                }
            }, initialLgData);
        case GET_LONG_READ_POST_PAGINATED_ERROR:
            return updateObjectById(state, (_2 = action.payload) === null || _2 === void 0 ? void 0 : _2.lgId, {
                pagination: __assign(__assign({}, (_4 = state[(_3 = action.payload) === null || _3 === void 0 ? void 0 : _3.lgId]) === null || _4 === void 0 ? void 0 : _4.pagination), { isLoading: false })
            }, initialLgData);
        case ADD_LR_POST_TIMEOUT_START:
            /*      return {
                    ...state,
                    isAddingPost: true,
                    blocks: [...state.blocks, action.payload]
                  }*/
            return updateObjectByIdAndAddBlocks(state, (_5 = action.payload) === null || _5 === void 0 ? void 0 : _5.lgId, (_6 = action.payload) === null || _6 === void 0 ? void 0 : _6.data, { isAddingPost: true }, (_7 = action.payload) === null || _7 === void 0 ? void 0 : _7.reverseParam);
        case ADD_MANY_LR_POST_TIMEOUT_START:
            /*      return {
                    ...state,
                    isAddingPost: true,
                    blocks: [...state.blocks, ...action.payload]
                  }*/
            return updateObjectByIdAndAddBlocks(state, (_8 = action.payload) === null || _8 === void 0 ? void 0 : _8.lgId, (_9 = action.payload) === null || _9 === void 0 ? void 0 : _9.data, { isAddingPost: true }, (_10 = action.payload) === null || _10 === void 0 ? void 0 : _10.reverseParam);
        case ADD_MANY_LR_POST_TIMEOUT_END:
            // return { ...state, isAddingPost: false }
            return updateObjectById(state, (_11 = action.payload) === null || _11 === void 0 ? void 0 : _11.lgId, { isAddingPost: false }, initialLgData);
        case ADD_LR_POST_TIMEOUT_END:
            // return { ...state, isAddingPost: false }
            return updateObjectById(state, (_12 = action.payload) === null || _12 === void 0 ? void 0 : _12.lgId, { isAddingPost: false }, initialLgData);
        case UPDATE_LR_POST_TIMEOUT_START:
            /*      return {
                    ...state,
                    isAddingPost: true,
                    blocks: [
                      ...state.blocks.filter(
                        (item) => action.payload.position != item.position
                      ),
                      action.payload
                    ]
                  }*/
            return updateObjectByIdAndAddBlocks(updateObjectByIdAndFilterBlocks(state, (_13 = action.payload) === null || _13 === void 0 ? void 0 : _13.lgId, (_15 = (_14 = action.payload) === null || _14 === void 0 ? void 0 : _14.data[0]) === null || _15 === void 0 ? void 0 : _15.position, { isAddingPost: true }), (_16 = action.payload) === null || _16 === void 0 ? void 0 : _16.lgId, (_17 = action.payload) === null || _17 === void 0 ? void 0 : _17.data, {});
        case UPDATE_LR_POST_TIMEOUT_END:
            // return { ...state, isAddingPost: false }
            return updateObjectById(state, (_18 = action.payload) === null || _18 === void 0 ? void 0 : _18.lgId, { isAddingPost: false }, initialLgData);
        case LONGREAD_RESET_REQUESTED:
            // return { ...initialState }
            return filterObjectById(state, (_19 = action.payload) === null || _19 === void 0 ? void 0 : _19.lgId);
        default:
            return state;
    }
}
export function getCurrentLongread(state, lgId) {
    return state.longreadBlocks[lgId] || initialLgData;
}
export function getAllLongreadBlocks(state) {
    return state.longreadBlocks || [];
}
export function getLongreadList(state) {
    return state.longreadBlocks || [];
}
/*

        {
          id: `question-1`,
          type: 1,
          title: `Giant Octopus boiled in citric acid and rose water. Ph'n 1`,
          isConnect: true,
          isDrag: true,
          answers: [
            {
              id: 11,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
              Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
              feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
              vitae at lobortis faucibus. Molestie cursus et euismod in. Diam ullamcorper nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.</p>`
            },
            {
              id: 12,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
              Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
              feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
              vitae at lobortis faucibus. Molestie cursus et euismod in</p>`
            },
            {
                id: 13,
                type: 'text',
                isDrag: true,
                isCut: true,
                text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
                Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
                feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
                vitae at lobortis faucibus. Molestie cursus et euismod in </p>`
            },
            {
              id: 14,
              isDrag: true,
              isCut: true,
              type: 'image',
              url: ``
            }
          ]
        },
        {
          id: `question-2`,
          type: 2,
          title: `Giant Octopus boiled in citric acid and rose water. Ph'n 1`,
          isConnect: true,
          isDrag: true,
          answers: [
            {
              id: 21,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p>orem ipsum dolor sit amet, consectetur adipiscing elit. Sed egestas orci fermentum id posuere consequat, augue vivamus et.
              Vel turpis condimentum quis nunc, tellus massa cursus eu ipsum. Velit magna mollis sagittis libero tempus et ac. Nunc sed aliquet amet
              feugiat et tellus morbi. Nulla sapien pellentesque nulla non eget dictum. Quis morbi elementum gravida non nisl. Egestas id cras diam
              vitae at lobortis faucibus. Molestie cursus et euismod in. Diam ullamcorper nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.</p>`
            },
            {
              id: 22,
              type: 'text',
              isDrag: true,
              isCut: true,
              text: `<p> et euismod in. Diam ullamcorper nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.et euismod in. Diam ullamcorper
              nam aenean laoreet in ut leo. Elit a penatibus cursus leo ac
              orci morbi adipiscing. Vestibulum felis accumsan libero etiam vel.
              Pulvinar sit arcu tristique eleifend.in settled regions.</p>`
            },
          ]
        },
        {
          id: 'question-3',
          type: 4,
          isConnect: true,
          isDrag: true,
          name: `<p>Конкретно-принципиальная республика Флорида расположена в 80-х меридианах Запада, и входит в Лигу Геркулеса. </p>`
        },
        {
          id: 'question-4',
          type: 5,  // блок соревнуйтесь
          isConnect: true,
          isDrag: true,
          title: 'Соревнуйтесь',
          name: `<p>Легенды и мифы Лиги Геркулеса принадлежат всем странам, входящим в нее.
          Но у каждой страны должна быть и собственная мифология.
          Также и Конкретно-принципиальная республика Флорида нуждается в своих легендах, сказках, анекдотах и тостах.</p>`
        },
        {
          id: 'question-5',
          type: 6,  // блок с лигами
          isConnect: true,
          isDrag: true,
          title: 'Соревнуйтесь',
          name: `<p>Ознакомьтесь с правилами турниров, проходящих в этих Лигах, принимайте в них участие и побеждайте!</p>`,
          leagues: [
            {
              name: 'Лига пчелы'
            },
            {
              name: 'Лига орла'
            },
            {
              name: 'Лига Рыцарей'
            },
            {
              name: 'Лига Единорога'
            },
            {
              name: 'Лига Медведя'
            },
            {
              name: 'Лига Льва'
            },
            {
              name: 'Лига Дракона'
            },
          ]
        }
*/
//# sourceMappingURL=longreadBlocks.js.map